module.exports = __webpack_public_path__ + "img/ais.eccf8ddb.png";